export default "__VITE_ASSET__DZ6Os0u4__"